import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';

import { FormStepType, GTMService } from '@shared/gtm';
import { IconComponent, PhonePipe } from '@shared/ui-shared';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'csl-available-places-info',
  standalone: true,
  imports: [PhonePipe, IconComponent],
  templateUrl: './available-places-info.component.html',
  styleUrl: './available-places-info.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex bg-green-200 px-4 py-6 md:pl-7 text-blue-900',
  },
})
export class AvailablePlacesInfoComponent {
  private readonly dialogService = inject(DialogService);
  private readonly gtmService = inject(GTMService);
  private readonly destroyRef = inject(DestroyRef);
  readonly contactPhone = globalThis.hostConfig.CONTACT_PHONE;

  formStep = input.required<FormStepType>();
  isCitiesDialogPending = signal(false);

  openCitiesDialog() {
    if (this.isCitiesDialogPending()) {
      return;
    }
    this.isCitiesDialogPending.set(true);
    this.dialogService
      .openTownsDialog(this.formStep())
      .pipe(
        finalize(() => this.isCitiesDialogPending.set(false)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({ error: () => console.error('Error opening cities dialog') });
    this.gtmService.formStep1Event(null, this.formStep(), null);
  }

  isResidentialService(): boolean {
    return this.formStep() === 'residential';
  }
}
